import { API_ENDPOINT } from ".";

export const getProductsInfoAPI = async () => {
  try {
    const response = await fetch(`${API_ENDPOINT}/products`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
    });
    return response;
  } catch (err) {
    console.error(err);
  }
};
export const updateDietaryRequirement = async (
  userId: number,
  dietaryRequirement: string
) => {
  try {
    const response = await fetch(`${API_ENDPOINT}/update-dietary-requirement`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ userId, dietaryRequirement }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error registering for event:", err);
    throw err; // Re-throw the error so it can be handled by the caller
  }
};
